// extracted by mini-css-extract-plugin
export default {"caption":"PhuHuynhChildList_caption__HY2HF","list_horizontal":"PhuHuynhChildList_list_horizontal__5B9cS","list_horizontal_item":"PhuHuynhChildList_list_horizontal_item__ggg0N"};